import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=44ae2311"
import script from "./RegionPicker.vue?vue&type=script&lang=js"
export * from "./RegionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports